// extracted by css-extract-rspack-plugin
export default {"responsiveDecor":"MLXV5mMHOn0FgQta","decor":"Y8hJfJddosMz77yr","bowtie":"_V5GHNzdyj8tdLXc","flower":"b22hqRW8MWMMGHGE"};